import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Flag from "react-world-flags";
import { countries } from "country-list-json";
import { Container, Image, Form, Spinner, Dropdown } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./signup-verifyphone.css";

import logo2 from "../../../assets/images/logo2.png";
import responsivebg from "../../../assets/images/responsive-bg.png";
import backarrow from "../../../assets/images/backarrow.jpg";

import Stepper from "../Stepper";
import { API_URL } from "../../../api";
import { useCookies } from "../../../hooks/useCookies";
import { useAppContext } from "../../../Context/UseContext";
import SelectCountryModal from "../../Utility/SelectCountryModal";
import { countriesPhoneNumberLength } from "../../../data/countriesPhoneNumberLength";

export const SignupPhone = () => {
  const navigate = useNavigate();
  const { phoneNumber, setPhoneNumber } = useAppContext();
  const { setCookie, clearAllCookies } = useCookies();

  const [selectedCountry, setSelectedCountry] = useState("CA");
  const [selectedCountryInfo, setSelectedCountryInfo] = useState(
    countries.find(c => c.code === selectedCountry)
  );
  const [phoneNumberLength, setPhoneNumberLength] = useState(12);
  const [formattedPhoneNumber, setFormattedPhoneNumber] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  const getPhoneNumberLength = code =>
    countriesPhoneNumberLength.find(c => c.code === code)?.phoneLength || 10;

  const handleCountrySelect = (code) => {
    const countryInfo = countries.find(country => country.code === code);
    if (countryInfo) {
      setPhoneNumberLength(getPhoneNumberLength(code));
      setSelectedCountry(code);
      setSelectedCountryInfo(countryInfo);
      setPhoneNumber(""); 
      setFormattedPhoneNumber("");
      setShowModal(false);
    }
  };


  useEffect(() => {
    clearAllCookies();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async ({ coords }) => {
        try {
          const res = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coords.latitude}&longitude=${coords.longitude}&localityLanguage=en`
          );
          const data = await res.json();
          const code = data.countryCode || selectedCountry;
          handleCountrySelect(code);
        } catch (err) {
          console.error("Location fetch error:", err);
        }
      });
    }
  }, []);

  const handlePhoneNumberChange = e => {
    const raw = e.target.value.replace(/\D/g, "");
    let formatted = raw;
    if (raw?.length > 6)
      formatted = `(${raw.slice(0, 3)}) ${raw.slice(3, 6)}-${raw.slice(6, 10)}`;
    else if (raw?.length > 3) formatted = `(${raw.slice(0, 3)}) ${raw.slice(3)}`;
    else if (raw?.length > 0) formatted = `(${raw}`;

    setFormattedPhoneNumber(formatted);
    setPhoneNumber(raw);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (isSendingOtp) return;
    if (!phoneNumber) return setErrorMessage("*Phone is required");

    const completePhone = selectedCountryInfo.dial_code + phoneNumber;
    setLoading(true);
    setIsSendingOtp(true);
    setErrorMessage("");

    try {
      const res = await fetch(`${API_URL}user/signup/otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: completePhone }),
      });

      const result = await res.json();
      if (res.ok) {
        setCookie("phoneNumber", completePhone, 7);
        navigate("/entercode");
      } else {
        setErrorMessage(result.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("OTP error:", err);
      setErrorMessage("An error occurred. Please try again later.");
    } finally {
      setIsSendingOtp(false);
      setLoading(false);
    }
  };

  return (
    <div className="signupphone-container">
      <div className="signup-phone-bg">
        <Image className="responsive-bg" src={responsivebg} />
      </div>
      <Container className="signupphone-main">
        <Container className="signupphone-content">
          <Container className="logo-progressbar1">
            <Container className="logo-arrow1">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
              />
              <Image
                src={logo2}
                alt="Logo"
                className="logo1"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="Phone" />
          </Container>

          <Container className="verify-phone-details">
            <Form onSubmit={handleSubmit} className="verify-phone-form">
              <Form.Group
                controlId="formPhoneNumber"
                className="verify-form-group"
              >
                <Form.Label className="num-verify-lable">
                  What's your phone number?
                </Form.Label>
                <div className="d-flex align-items-center w-100">
                  <Dropdown>
                    <div
                      id="dropdown-basic"
                      onClick={() => setShowModal(true)}
                      className="flag-box"
                      style={{ borderColor: errorMessage ? "red" : "" }}
                    >
                      <Flag
                        code={selectedCountry}
                        style={{
                          width: "34px",
                          height: "25px",
                          marginRight: "10px",
                        }}
                      />
                      <span>{selectedCountryInfo?.dial_code}</span>
                    </div>
                  </Dropdown>
                  <Form.Control
                    className={`num-verify-input ${
                      errorMessage ? "error" : ""
                    }`}
                    type="tel"
                    placeholder="(xxx)xxx-xxxx"
                    value={formattedPhoneNumber}
                    onChange={handlePhoneNumberChange}
                    maxLength={phoneNumberLength + 4}
                    style={{ flex: 1, marginLeft: "10px" }}
                  />
                </div>
                {errorMessage && (
                  <Form.Text className="text-danger error-message">
                    {errorMessage}
                  </Form.Text>
                )}
              </Form.Group>
              <button
                type="submit"
                disabled={isSendingOtp}
                className="global-next-btn"
              >
                {loading ? <Spinner animation="border" size="sm" /> : "Next"}
              </button>
            </Form>

            <Container className="or-option">
              <Container className="or-line">
                <div className="line" />
                <span>or</span>
                <div className="line" />
              </Container>
              <p className="text-link">
                Already have an account?{" "}
                <a href="/signinoptions" className="signup-signin">
                  Sign in here
                </a>
              </p>
              <p className="text-link">
                By continuing you accept our{" "}
                <a className="signup-links" href="/PrivacyPolicy">
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a className="signup-links" target="_blank" href="/Tnc">
                  Terms of Use
                </a>
              </p>
            </Container>
          </Container>
        </Container>
      </Container>
      <SelectCountryModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSelectCountry={handleCountrySelect}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};
